// components/StickyFooter.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../index.css';
const StickyFooter = () => {
  return (
    <footer className="bg-dark text-light py-4" >
      <Container>
        {/* {    <Row>
          <Col md={1}>
            <h5>关于正日</h5>
            <ul className="list-unstyled">
              <li className="lh-lg"><a href="/" className="text-light text-decoration-none">公司简介</a></li>
              <li className="lh-lg"><a href="/about" className="text-light text-decoration-none">组织机构</a></li>
              <li className="lh-lg"><a href="/services" className="text-light text-decoration-none">企业文化</a></li>
              <li className="lh-lg"><a href="/contact" className="text-light text-decoration-none">资质荣誉</a></li>
              <li className="lh-lg"><a href="/contact" className="text-light text-decoration-none">企业风采</a></li>
            </ul>
          </Col>
          <Col md={1}>
            <h5>新闻资讯</h5>
            <ul className="list-unstyled">
              <li className="lh-lg"><a href="/" className="text-light text-decoration-none">公司新闻</a></li>
              <li className="lh-lg"><a href="/about" className="text-light text-decoration-none">行业动态</a></li>
            </ul>
          </Col>
          <Col md={2}>
            <h5>产品中心</h5>
            <ul className="list-unstyled">
              <li className="lh-lg">高压开关柜系列</li> 
              <li className="lh-lg">低压开关柜系列</li>
              <li className="lh-lg">变压器、高压元器件系列</li>
              <li className="lh-lg">低压元器件系列</li>
              <li className="lh-lg">静止无功动态补偿装置</li>
              <li className="lh-lg">有源滤波装置(APF)</li> 
              <li className="lh-lg">欧式箱式变电站</li>
              <li className="lh-lg">美式箱式变电站</li>
              <li className="lh-lg">高、低压成套设备</li>
              <li className="lh-lg">动力配电柜</li>
              <li className="lh-lg">电缆分支箱</li>
              <li className="lh-lg">变压器保护开关箱</li>
              <li className="lh-lg">配电箱</li>
              <li className="lh-lg">光伏防雷汇流箱</li>
            </ul>
          </Col>
          <Col md={2}>
            <h5>应用案例</h5>
            <ul className="list-unstyled">
              <li className="lh-lg">静止无功动态补偿装置</li>
              <li className="lh-lg">有源滤波装置(APF)</li>
              <li className="lh-lg">箱式变电站</li>
              <li className="lh-lg">高、低压成套设备</li>
              <li className="lh-lg">配电柜、配电箱</li>
            </ul>
          </Col>
          <Col md={2}>
            <h5>营销与服务</h5>
            <ul className="list-unstyled">
              <li className="lh-lg">营销与服务</li>
            </ul>
          </Col>
          <Col md={2}>
            <h5>解决方案</h5>
            <ul className="list-unstyled">
              <li className="lh-lg">解决方案</li>
            </ul>
          </Col>
          <Col md={1}>
            <h5>人才资源</h5>
            <ul className="list-unstyled">
              <li className="lh-lg">人才战略</li>
              <li className="lh-lg">用人理念</li>
              <li className="lh-lg">最新招聘</li>
            </ul>
          </Col>
          <Col md={1}>
            <h5>联系我们</h5>
            <ul className="list-unstyled">
              <li className="lh-lg">联系我们</li>
            </ul>
          </Col>
        </Row>
        <hr className="my-4 bg-light" /> */}
        {/* 修改为左右结构 */}
        <Row className="align-items-center">
          {/* 左侧版权信息 */}
          <Col md={8} className="text-center text-md-start">
            <p className="mb-1">&copy;版权所有：
              安徽合利电气股份有限公司</p>
            {/* <p className="mb-1">地址:安徽省桐城市经济开发区南四路66号 电话:0556-6160888 13733000080</p> */}
            <p className="mb-1">联系人：张女士  电话：0551-65650828</p>
            <p className="mb-1">皖ICP备20007342号-4</p>
          </Col>
          {/* 右侧二维码 */}
          <Col md={4} className="text-center mt-3 mt-md-0">
            <div className="d-flex flex-column align-items-center">
              <img
                src={`${process.env.PUBLIC_URL}/imgs/wx.png`}
                alt="合利股份二维码"
                className="qr-code"
                style={{
                  maxWidth: '120px',
                  height: 'auto',
                  border: '1px solid #6c757d',
                  borderRadius: '5px',
                  padding: '5px',
                  backgroundColor: 'white'
                }}
              />
              <div className="qr-title mt-2" style={{ fontSize: '14px', color: '#adb5bd' }}>
                扫描关注我们
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
export default StickyFooter;